<template>
  <v-container fluid>
    <v-layout wrap justify-center>
      <v-flex xs12 sm8 class="pa-1">
        <v-card>
          <v-card-title primary-title class="mx-auto">
            <v-card-text class="pa-0">
              <p class="title font-weight-light text-uppercase mb-0 text-xs-center">
                Usted ha seleccionado
              </p>
            </v-card-text>
          </v-card-title>
          <v-card-text>
            <Carrito />
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title primary-title class="mx-auto">
            <v-card-text class="pa-0">
              <p class="title font-weight-light text-uppercase mb-0 text-xs-center">
                Facturación
              </p>
            </v-card-text>
          </v-card-title>
          <v-card-text>
            <v-form @submit.prevent="reservar" autocomplete="off" id="formfacturacion">
              <v-container>
                <v-layout wrap>
                  <v-flex xs12>
                    <p v-if="usuario.nivel == 0" class="text-xs-center font-weight-regular subheading">
                      <strong class="text-success">{{ form.agencia.nombre }}</strong>
                    </p>
                  </v-flex>

                  <v-flex xs12>
                    <v-autocomplete
                      v-model="form.agencia"
                      :items="entidades"
                      color="white"
                      item-text="nombre"
                      label="Seleccione una agencia"
                      name="agencia"
                      v-validate="'required'"
                      :error="errors.has('agencia')"
                      :error-messages="errors.first('agencia')"
                      return-object
                      v-if="usuario.nivel == 2"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 v-if="usuario.nivel == 2">
                    <v-text-field
                      v-model="form.nfile"
                      type="text"
                      v-validate="'min_value:200000|numeric'"
                      label="Número de file (Opcional)"
                      name="nfile"
                      data-vv-as="número de file"
                      data-vv-delay="1000"
                      :error="errors.has('nfile')"
                      :error-messages="errors.first('nfile')"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 v-if="false">
                    <v-checkbox
                      v-model="pagaAntes"
                      label="Realiza pago antes de reservar ¡Cambiar mensaje!"
                      required
                      name="paga"
                      v-if="usuario.nivel == 0"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12>
                    <v-checkbox
                      v-model="form.terminos"
                      v-validate="'required:true'"
                      data-vv-as="terminos"
                      name="terminos"
                      :error="errors.has('terminos')"
                      :error-messages="errors.first('terminos')"
                      class="mt-0"
                    >
                      <template v-slot:label>
                        <div>
                          Acepto
                          <a @click.stop="verTerminos = true">
                            téminos y condiciones
                          </a>
                        </div>
                      </template>
                    </v-checkbox>
                  </v-flex>
                  <v-btn color="primary" type="submit" :disabled="redirecting || disableReservar">
                    <v-icon small v-if="redirecting">fas fa-circle-notch fa-spin</v-icon>
                    <span v-else>Reservar </span>
                  </v-btn>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="verTerminos" scrollable>
      <v-card tile>
        <v-toolbar card dark class="headline red darken-4">
          <v-btn icon dark @click="verTerminos = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <strong><p>CONDICIONES DE CONTRATACION</p></strong>
          <p>
            SEÑA 5% Y SALDO 30 DIAS ANTES DE LA FECHA DE INICIO DEL PRIMER SERVICIO :
          </p>
          <strong><p>DOCUMENTACIÓN:</p></strong>
          <p>
            Para los viajes al exterior es necesario atender a la legislación vigente en cada caso. Como información
            meramente orientativa, destacamos la documentación obligatoria para poder viajar válida para ciudadanos
            ARGENTINOS:
          </p>
          <ul>
            <li>
              Documento Nacional de Identidad.
            </li>
            <li>
              Pasaporte (cuyo vencimiento sea posterior a la fecha de retorno).
            </li>
            <li>
              Los menores de 18 años deberán viajar en compañía de sus padres quienes lo acreditarán presentando LIBRETA
              DE FAMILIA o PARTIDA DE NACIMIENTO ORIGINAL.
            </li>
            <li>
              Si viajan con uno solo de los progenitores, deberán contar con una autorización del otro progenitor.
            </li>
            <li>
              Si viajan con terceros y sin ninguno de sus progenitores, dicha autorización deberá ser otorgada
              especialmente por ambos progenitores, con precisa indicación de fecha de partida, destino, fecha de
              retorno e identidad del tercero con quien viajará el menor.
            </li>
            <li>
              En caso de uno de los padres haya fallecido, deber presentar el Acta de Defunción junto a la Partida de
              Nacimiento del menor, en su defecto la Libreta de Familia donde estén registradas las dos situaciones.
            </li>
            <li>
              Se requerirá autorización complementaria de alguno de los abuelos cuando el menor sea hijo de progenitores
              adolescentes (mayores de 13 años y menores de 18 años), y si estos no están casados, necesitarán la
              autorización de sus padres, de acuerdo a la regla general. Esta autorización puede ser tácita o expresa,
              aunque en caso de imposibilidad o desacuerdo en el otorgamiento de la autorización complementaria, se
              requerirá la venia judicial.
            </li>
            <li>
              Si viaja un menor adolecente (mayor de 13 años y menor de 18 años), se requerirá su consentimiento expreso
              (conf. artículo 645 último párrafo del Código Civil y Comercial de la Nación). Este consentimiento se
              tendrá por materializado con su presentación voluntaria ante la autoridad encargada de efectuar el control
              migratorio al momento del egreso (Procedimiento de Menores, artículo 14, Dirección Nacional de
              Migraciones).
            </li>
          </ul>
          <p>Documentación válida para ciudadanos EXTRANJEROS:</p>
          <ul>
            <li>
              En el caso de extranjeros que vivan en Argentina utilizarán la misma documentación que los nativos, con la
              salvedad de que en caso de viajar con Documento Nacional de Identidad deberán ser residentes permanentes.
              En el caso de extranjeros procedentes de países a los que la República Argentina les exige VISA, deberán
              viajar con el pasaporte de su país de origen, el que tendrá la intervención consular correspondiente.
            </li>
            <li>
              Conforme Disp. DNM 899/13 relativa a la vigencia de Permanencia en Argentina, en el momento de efectuar el
              check in en Buenos Aires, le será solicitado a los pasajeros extranjeros la Tarjeta Migratoria con la que
              embarcaron en el puerto de origen o, en caso que la misma hubiera sido extraviada o el pasajero hubiera
              excedido el plazo de permanencia permitido en Argentina, le será solicitado el Certificado de Habilitación
              de Salida con la constancia de multa abonada. Sin la documentación mencionada, el pasajero no podrá ser
              embarcado.
            </li>
          </ul>
          <p>
            La información aquí brindada es orientativa. Por favor consultar la documentación necesaria para viajar en
            la Dirección Nacional de Migraciones (Tel: (011) 4317-0388/0250) o en su página web
            <a href="http://www.migraciones.gov.ar/accesible/indexP.php" target="_blank">www.migraciones.gov.ar</a>,
            como así también los visados necesarios para viajar ante el consulado que corresponda.
          </p>
          <p>
            All Seasons S.R.L. no se responsabiliza por la documentación personal que faltare, por su estado o vigencia
            al momento de la realización del viaje, como así también de los perjuicios o pérdidas que resultaren de
            dicha situación.
          </p>
          <ol type="a">
            <li>
              Cuando se trate del desistimiento de servicios confirmados y abonados por el pasajero o por la agencia, el
              reintegro de los importes abonados en caso de cancelación dependerá de la política de reintegros
              determinada por cada uno de los prestadores finales de los servicios contratados. En tal sentido, se
              recuerda que All Seasons S.R.L.
              <strong
                >sólo opera como un intermediario entre el pasajero y el prestador final de los servicios contratados
                (conf. Ley 18.829)</strong
              >.
            </li>
            <li>
              All Seasons S.R.L. no es responsable por los servicios que no fueran tomados por el pasajero en el tiempo
              y la forma convenida, ni por las consecuencias que en virtud de ello surjan, tales como la cancelación de
              los servicios por parte del prestador, ni por el reintegro o devolución del importe abonado por dicho
              servicio.
            </li>
            <li>
              En caso de devolución de pasajes aéreos, hoteles, cruceros y alquiler de auto, de acuerdo con las
              políticas determinadas por cada uno de los prestadores finales de los servicios contratados (conf.
              cláusula a)), el pasajero deberá abonar a All Seasons S.R.L. un cargo administrativo del diez por ciento
              (10%) del importe total de la compra.
            </li>
            <li>
              La modificación de las fechas estipuladas en la reserva de pasajes aéreos, hoteles, cruceros, alquiler de
              auto y cualquier otro servicio contratado por el pasajero, ya sea su postergación o antelación, podrá
              realizarse de acuerdo con las modalidades, condiciones y disponibilidad de cada prestador de servicios (en
              tal sentido, es el prestador final de los servicios quien determina la penalidad correspondiente ante esta
              modificación, además de las diferencias tarifarias por cambio de temporada, si correspondieran), con más
              un cargo administrativo del diez por ciento (10%) del importe total de la compra, a favor de All Seasons
              S.R.L.. All Seasons S.R.L. queda eximida de toda responsabilidad en caso de no poder confirmar los cambios
              solicitados por el pasajero.
            </li>
            <li>
              Todo reclamo o reembolso de dinero por servicios tomados deberá ser solicitado dentro de los 30 (treinta)
              días de finalizado el viaje, por correo electrónico a la dirección . . . . . . . . . . . . . . . . . . . .
              . ., acompañados de comprobantes y documentación respaldatoria. All Seasons S.R.L. no asumirá ningún cargo
              y/o costo y/o impuesto y/o gravamen derivados de la transferencia bancaria o similares que se utilicen
              para realizar la devolución y/o reembolso.
            </li>
          </ol>
          <strong><p>RESPONSABILIDAD:</p></strong>
          <p>
            All Seasons S.R.L. – Legajo N° 4470, declara expresamente que actúa en el carácter de intermediaria, en la
            reserva o contratación de los distintos servicios turísticos, entre el consumidor y los prestadores de
            dichos servicios tales como hoteles, empresas de transporte, líneas aéreas, ferrocarriles, líneas marítimas,
            agencias mayoristas, restaurantes u otros prestadores en general. La empresa no se responsabiliza por los
            hechos que se produzcan por caso fortuito o fuerza mayor, retrasos, huelgas, fenómenos climáticos o hechos
            de la naturaleza tales como terremotos, inundaciones, cuarentenas, etc., que acontezcan antes o durante el
            desarrollo del tour y que impidan, demoren o de cualquier modo obstaculicen la ejecución total o parcial de
            las prestaciones contratadas, de conformidad con lo dispuesto por el Código Civil y Comercial de la Nación.
            Asimismo, declina todo tipo de responsabilidad por pérdida, daño, accidente, falencias en los servicios o
            cualquier irregularidad que pudiera ocurrir a los pasajeros y sus pertenencias cuando sean motivados por
            terceros ajenos al control de la empresa. La Empresa no asume responsabilidad alguna ante los posibles
            cambios de horarios originados por terceros, tales como compañías aéreas y de ómnibus.
          </p>
          <strong><p>ALTERACIONES O MODIFICACIONES:</p></strong>
          <ul>
            <li>
              La empresa informa que los prestadores finales de los servicios contratados pueden alterar total o
              parcialmente, sin previo aviso, el ordenamiento diario de servicios contratados, antes o durante la
              ejecución de los mismos.-
            </li>
            <li>
              Si por cualquier motivo operativo y/o de contingencia no imputable a la Empresa, fuera necesario un cambio
              de hoteles contratados, la Empresa se compromete a gestionar ante el proveedor final otros de igual o
              mayor categoría dentro del mismo núcleo urbano sin cargo alguno para el pasajero y no teniendo este último
              derecho a indemnización alguna.
            </li>
            <li>
              Una vez comenzado el viaje, la suspensión, modificación o interrupción de los servicios por parte del
              pasajero por razones personales de cualquier índole, no dará lugar a reclamo alguno respecto de All
              Seasons S.R.L..
            </li>
          </ul>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Carrito from "@/components/utiles/Carrito.vue"
import { mapGetters } from "vuex"
export default {
  name: "pagador",
  components: {
    Carrito
  },
  created() {
    this.initFacturacion()
  },
  mounted() {},
  props: ["data"],
  methods: {
    reservar() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.isAuth2Reservar()
          return
        }
      })
    },
    isAuth2Reservar() {
      this.disableReservar = true
      var usuario = this.$passporthandler.getDatosUsuarios()
      if (usuario != false) {
        this.processReserva(usuario)
        return
      }
      this.$toasted.error("No se detectó la sesión.", {
        theme: "toasted-primary",
        position: "top-right",
        duration: 2000
      })
      this.$router.replace({ name: "login" })
    },
    async processReserva(usuarioWeb) {
      const data = {
        hoteles: this.data.hoteles,
        cupos: this.data.cupos,
        tickets: this.data.tickets,
        traslados: this.data.traslados
      }
      if (this.pagaAntes) {
        this.getUrlPago(data, usuarioWeb)
        return
      }
      console.log("reservar")
      this.postReserva(usuarioWeb, data)
    },
    async postReserva(usuarioWeb, data) {
      await this.$reservaControllerAs.procesar(usuarioWeb, this.form, data)
      if (process.env.NODE_ENV == "development") {
        this.disableReservar = false
      }
      this.manejarRsReserva(this.$reservaControllerAs.getRs(), usuarioWeb, this.form.agencia)
    },
    async getUrlPago(data, usuarioWeb) {
      this.redirecting = true
      const reserva = data
      const carrito = this.servicios
      //const token = this.$passporthandler.tomarToken();
      const rq = {
        mensaje: { reserva: reserva, carrito: carrito, usuarioWeb: usuarioWeb },
        pagar: true,
        proveedor_pago_id: 9
      }
      await this.$reservaControllerAs.saveReserva(rq)
      const rs = this.$reservaControllerAs.getRs()
      this.manejoRsUrlPago(rs)
    },
    manejoRsUrlPago(rs) {
      if (rs.pago.status === 200) {
        window.location.href = rs.pago.url
        return
      }
      this.showToasted(
        "Ocurrio un error iniciando el motor de pagos, por favor intente nuevamente, en caso de persistir, contacte al administaodr",
        "error",
        10000
      )
    },
    manejarRsReserva(rs, usuarioWeb, agencia) {
      try {
        if (rs.resumen.status === 200) {
          var resumen = {
            resumen: rs.resumen,
            usuario: usuarioWeb,
            agencia: agencia
          }
          this.$router.push({ name: "resumen", params: { data: resumen } })
          return
        }
        this.manejoRsError(rs)
      } catch (e) {
        console.log(e)
      }
    },
    initFacturacion() {
      if (this.usuario.nivel == 0) {
        this.form.agencia = {
          id: this.usuario.idagencia,
          nombre: this.usuario.agencia,
          cuit: this.usuario.cuit
        }
        return
      }
      this.entidades = this.data.rs.entidades
    },
    manejoRsError(rs) {
      var _this = this
      switch (rs.status) {
        case 401:
          this.$toasted.error(rs.reserva.detail, {
            theme: "toasted-primary",
            position: "top-right",
            duration: 3000
          })
          setTimeout(function() {
            _this.$router.replace({ name: "login" })
          }, 2000)
          break

        default:
          this.$toasted.error("Ocurrió un error inesperado, por favor contacte al administrador.", {
            theme: "toasted-primary",
            position: "top-right",
            duration: 3000
          })
          break
      }
    }
  },
  data() {
    return {
      nombre: "pagador",
      entidades: [],
      form: { agencia: null, terminos: false, nfile: null },
      // seleccionado : null,
      mensajeEr: null,
      pagaAntes: false,
      verTerminos: false,
      redirecting: false,
      disableReservar: false
    }
  },
  computed: {
    ...mapGetters("app", {
      usuario: "getUsuario"
    }),
    ...mapGetters("carrito", {
      servicios: "cartServicios"
    })
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "buscandox") {
      this.$router.go(-1)
    }
    next()
  }
}
</script>
